/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InventoryQueueMessageAcknowledgeResponse { 
    /**
     * All message ids which were not able to be acknowledged
     */
    acknowledge_failed_messages?: Array<string>;
    /**
     * Count of inventory queue messages not acknowledged
     */
    failed_count?: number;
    /**
     * Count of inventory queue messages successfully acknowledged
     */
    success_count?: number;
    /**
     * Total count of inventory queue messages to be acknowledged
     */
    total_count?: number;
}

